import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const RoleBasedRoute = ({ children, allowedRoles = [], redirectTo = '/dashboard' }) => {
  const { currentUser: user } = useAuth();

  // Eğer allowedRoles boşsa, tüm rollere izin ver
  if (allowedRoles.length === 0) {
    return children;
  }

  // Kullanıcının rolü izin verilen roller arasında mı kontrol et
  if (!user?.role || !allowedRoles.includes(user.role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default RoleBasedRoute;